(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('CompositeSearch', CompositeSearch);

    CompositeSearch.$inject = ['$resource'];

    function CompositeSearch($resource) {
        var resourceUrl =  'api/_search/composites/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
